import store from "../store";

export function toArray(subject, customKey = "languageContent") {
    const newSubject = goClone(subject);

    if (newSubject[customKey] != null) {
        const languageContents = [];
        for (const key of Object.keys(newSubject[customKey])) {
            const languageContent = newSubject[customKey][key];
            if (languageContent != null) {
                languageContent.languageCode = key;
                languageContents.push(languageContent);
            }
        }
        newSubject[customKey] = languageContents;
    }

    return newSubject;
}

export function toObject(item, customKey = "languageContent") {
    const newItem = goClone(item);
    const languageContents = {};
    const isArr = Array.isArray(item[customKey]);
    if (newItem[customKey] != null && isArr) {
        for (const lContent of newItem[customKey]) {
            languageContents[lContent.languageCode] = lContent;
        }
        const languages = store.state.language.languages;
        //if there is not content for language use en as default
        languages.forEach((lang) => {
            if (!languageContents.hasOwnProperty(lang.code)) {
                languageContents[lang.code] = {
                    ...languageContents["en"],
                    languageCode: lang.code,
                };
            }
        });
    } else {
        languageContents["tr"] = {};
        languageContents["en"] = {};
    }
    newItem[customKey] = languageContents;
    return newItem;
}

function goClone(source) {
    let clone;
    if (Object.prototype.toString.call(source) === "[object Array]") {
        clone = [];
        for (let i = 0; i < source.length; i++) {
            clone[i] = goClone(source[i]);
        }
        return clone;
    } else if (typeof source == "object" && source != null) {
        clone = {};
        for (const prop in source) {
            if (source.hasOwnProperty(prop)) {
                clone[prop] = goClone(source[prop]);
            }
        }
        return clone;
    } else {
        return source;
    }
}



// WEBPACK FOOTER //
// ./src/utils/languageContent.js